
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';


export const becomeTeamMember = createAsyncThunk(
    'teamMember/become',
    async ({ token, passcode }, {rejectWithValue}) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/accounts/team-person`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        passcode: passcode,
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (response.data) {
                return response.data;
            } else {
                return rejectWithValue("Failed to fetch ");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data.message || "Unknown error");
        }
    }
);

const teamMemberSlice = createSlice({
    name: 'teamMember',
    initialState: {
        isLoading: false,
        error: null,
        response: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(becomeTeamMember.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(becomeTeamMember.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
                toast.success(action.payload.message)
            })
            .addCase(becomeTeamMember.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload)

            });
    },
});

export default teamMemberSlice.reducer;
